import { ColumnOrderState } from '@tanstack/react-table';

export const mergeColumnOrder = (storedOrder: ColumnOrderState, columnIds: string[]): ColumnOrderState => {
    const knownIds = new Set(columnIds);
    const order = storedOrder.filter((id, index) => knownIds.has(id) && storedOrder.indexOf(id) === index);

    columnIds.forEach((id, index) => {
        if (order.includes(id)) return;

        const predecessorIndex = index === 0 ? -1 : order.indexOf(columnIds[index - 1]);
        order.splice(predecessorIndex + 1, 0, id);
    });

    return order;
};
